<template>
  <div class="bg-white p-8 flex w-full">
    <div class="w-5/12 pr-8"><Plans /></div>
    <div class="w-7/12 px-5">
      <iframe
        src="https://books.zoho.in/portal/brained"
        class="w-full"
        height="610"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </div>
</template>
<script>
import Plans from "@/views/adminPanel/pages/ecommerce/components/Plans.vue";
export default {
  components: {
    Plans,
  },
};
</script>
